import { useEffect, useState } from 'react';

import { getSyncEngine, type SyncConnection } from './engine';

/**
 * Subscribe to the sync engine's backend-connectivity snapshot. The engine
 * returns a stable reference until a field changes, so re-renders only happen
 * on real transitions (online <-> offline, pending-count changes).
 */
export function useSyncConnection(): SyncConnection {
  const engine = getSyncEngine();
  const [connection, setConnection] = useState<SyncConnection>(() => engine.getConnection());

  useEffect(() => {
    setConnection(engine.getConnection());
    return engine.subscribe(() => {
      setConnection(engine.getConnection());
    });
  }, [engine]);

  return connection;
}
